import { render, staticRenderFns } from "./app-bar.vue?vue&type=template&id=2d2896d3&scoped=true&"
var script = {}
import style0 from "./app-bar.vue?vue&type=style&index=0&id=2d2896d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2896d3",
  null
  
)

export default component.exports